/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import parameters from './__generated__/JiraProjectsTemplateListRightPanelContainerQuery$parameters';
import type { JiraProjectsTemplateListRightPanelContainerQuery } from './__generated__/JiraProjectsTemplateListRightPanelContainerQuery.graphql.ts';

type Queries = {
	templatesQueryRef: JiraProjectsTemplateListRightPanelContainerQuery;
};

type RecommendationsInProjectListEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const RecommendationsInProjectListEntryPoint: EntryPoint<
	RecommendationsInProjectListEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<RecommendationsInProjectListEntryPointComponent>(
		/* webpackChunkName: "projects-directory-templates-sidebar" */ './JiraProjectsTemplateListRightPanelContainer.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: (extraProps: EntryPointRouteParams) => ({
		extraProps,
		queries: {
			templatesQueryRef: {
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
				parameters,
				variables: {
					cloudId: extraProps.tenantContext.cloudId,
					isAnonymous: extraProps.tenantContext.isAnonymous,
					isAllowingEndUsersToAccessCustomTemplates: fg(
						'allow_end_users_to_access_custom_templates',
					),
				},
			},
		},
	}),
});
